/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { MemcachedInstrumentation } from './instrumentation';
export type { InstrumentationConfig } from './types';
